const VIEWCOUNT_THRESHOLD_IN_SECONDS = 30;

export const shouldSendView = (
  currentTime: number | undefined,
  song: { id: string } | null | undefined,
  songViewSent: boolean,
): song is { id: string } => {
  if (!song || songViewSent || !currentTime || Number.isNaN(currentTime)) {
    return false;
  }

  return currentTime > VIEWCOUNT_THRESHOLD_IN_SECONDS;
};
